/**
 * Formatter - Month
 */

// eslint-disable-next-line import/prefer-default-export
import { FormatDate } from './date'

// eslint-disable-next-line import/prefer-default-export
export const FormatMonth = (startDate: string) =>
  FormatDate(startDate, 'MMMM').toUpperCase()
